<ng-container *ngIf="this.TransitionDirection == this.Backwards">
    <!-- NOTE:  THE FOLLOWING <div/> USES FLEX DIRECTION ROW-REVERSE. -->
    <div class="workflow-backward-transitions-div">

        <!-- Create a right margin (for spacing). -->
        <div class="forward-transition-right-margin-div"></div>

        <!-- Draw backward transitions one workflow state segment at a time. -->
        <ng-container *ngFor="let workflowState of this.WorkflowStates; let iState=index">

            <!-- Handle all but the last workflow state one way. -->
            <ng-container *ngIf="(iState < this.WorkflowStateCount - 1)">
                <div class="{{this.BackwardTransitionWorkflowStateDivClass(workflowTransition,workflowState)}}"
                     (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition, workflowState, true)"
                     matTooltip="{{this.TransitionConnectorTooltip}}"
                     [matTooltipPosition]="this.TooltipPosition">
                </div>

                <div class="{{this.BackwardTransitionConnectionDivClass(workflowTransition,workflowState)}}"
                     (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition, workflowState, false)"
                     matTooltip="{{this.TransitionConnectorTooltip}}"
                     [matTooltipPosition]="this.TooltipPosition">
                </div>
            </ng-container>

            <!-- Handle the last workflow state differently. -->
            <ng-container *ngIf="(iState == this.WorkflowStateCount - 1)">
                <div class="{{this.BackwardTransitionWorkflowStateDivClass(this.WorkflowTransition,workflowState)}}"
                     (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition, workflowState, true)"
                     matTooltip="{{this.TransitionConnectorTooltip}}"
                     [matTooltipPosition]="this.TooltipPosition">
                </div>
            </ng-container>

        </ng-container>

        <!-- Create a left margin (for spacing). -->
        <div class="forward-transition-left-margin-div"></div>

    </div>

    <!-- Define a transition name div that will overlay the above transition div. -->
    <div *ngIf="true"
         class="backward-workflow-transition-name-outer-div">

        <!-- Create a right margin (for spacing). -->
        <div *ngIf="true"
             class="forward-transition-right-margin-div"></div>


        <!-- Create additional spacing for any states before this transition. -->
        <div *ngFor="let workflowState of this.WorkflowStatesBeforeTransition"
             class="workflow-state-before-transition-name-div">
        </div>

        <div class="left-arrow-div">
            <mat-icon (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition,null,false)">arrow_right_alt</mat-icon>
        </div>

        <!-- Define a permissions popover. -->
        <ng-container>
            <ng-template #backwardPermissionsPopoverTitle><b>{{this.WorkflowTransitionPermissionsPopoverTitle}}</b></ng-template>
            <ng-template #backwardPermissionsPopoverContent>
                <ng-container *ngIf="this.PermissionCount == 0">
                    <p>No permissions defined.</p>
                </ng-container>
                <ng-container *ngIf="this.PermissionCount > 0">
                    <table>
                        <tr>
                            <th>Role</th>
                            <th>Permissions</th>
                        </tr>

                        <ng-container *ngFor="let permissionInfo of this.workflowTransition.Permissions">
                            <tr *ngIf="this.GetPermissionNames(permissionInfo).length > 0">
                                <td>{{permissionInfo.roleName}}</td>
                                <td>{{this.GetPermissionNames(permissionInfo)}}</td>
                            </tr>
                        </ng-container>
                    </table>
                </ng-container>
            </ng-template>
        </ng-container>

        <!-- Draw the transition's name. -->
        <!--
             Define one of two transition names, either:
                 1. A transition that accepts a role name drop in 'Permissions' mode; or
                 2. A transition that can be dragged to the trash in 'Build' mode.
        -->
        <div *ngIf="(this.ViewingMode == this.ViewingModePermissionsMode)"
             droppable
             [dropScope]="this.DropScope"
             [dropEnabled]="true"
             (onDrop)="this.outputRoleDroppedOnWorkflowTransition($event,this.WorkflowTransition)"
             class="workflow-transition-name-div"
             (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition,null,false)"
             [popoverTitle]="backwardPermissionsPopoverTitle"
             [ngbPopover]="backwardPermissionsPopoverContent"
             placement="bottom"
             #p="ngbPopover"
             triggers="manual"
             (hidden)="this.permissionsPopoverHidden()">
            <p>{{this.WorkflowTransition.name}}</p>
        </div>
        <div *ngIf="this.ViewingMode == this.ViewingModeBuilderMode"
             class="workflow-transition-name-div"
             draggable
             [dragScope]="this.DragScope"
             [dragData]="this.WorkflowTransition"
             (onDragStart)="this.outputExistingWorkflowTransitionDragStart($event,this.WorkflowTransition)"
             (onDragEnd)="this.outputExistingWorkflowTransitionDragEnd($event)"
             (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition,null,false)"
             [popoverTitle]="backwardPermissionsPopoverTitle"
             [ngbPopover]="backwardPermissionsPopoverContent"
             placement="bottom"
             #p="ngbPopover"
             triggers="manual"
             (hidden)="this.permissionsPopoverHidden()"
             (contextmenu)="this.displayWorkflowTransitionContextMenu($event, this.WorkflowTransition); false;">
            <p>{{this.WorkflowTransition.name}}</p>
        </div>
        <!-- End the definition of two types of transition names. -->

        <div class="left-arrow-div">
            <mat-icon (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition,null,false)">arrow_right_alt</mat-icon>
        </div>


        <!-- Create additional spacing for any states after this transition. -->
        <div *ngFor="let workflowState of this.WorkflowStatesAfterTransition"
             class="workflow-state-after-transition-name-div">
        </div>

        <!-- Create a left margin (for spacing). -->
        <div *ngIf="true"
             class="forward-transition-left-margin-div"></div>

    </div>



    <!--//VNEXT-348: KLW - Comment out for now-->
    <!--<div style="visibility: hidden; position: fixed"
         [style.left]="this.WorkflowTransitionMenuPositionX"
         [style.top]="this.WorkflowTransitionMenuPositionY"
         [matMenuTriggerFor]="workflowTransitionContextMenu"
         #workflowTransitionMenuTrigger>
    </div>

    <mat-menu #workflowTransitionContextMenu="matMenu">
        <button mat-menu-item>
            Delete ...
        </button>
    </mat-menu>-->

</ng-container>


<ng-container *ngIf="this.TransitionDirection == this.Forwards">

    <div class="workflow-forward-transitions-div">

        <!-- Create a left margin (for spacing). -->
        <div class="forward-transition-left-margin-div"></div>

        <!-- Draw forward transitions one workflow state segment at a time. -->
        <ng-container *ngFor="let workflowState of this.WorkflowStates; let iState=index">

            <!-- Handle all but the last workflow state one way. -->
            <ng-container *ngIf="(iState < this.WorkflowStateCount - 1)">
                <div class="{{this.ForwardTransitionWorkflowStateDivClass(workflowTransition,workflowState)}}"
                     (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition, workflowState, true)"
                     matTooltip="{{this.TransitionConnectorTooltip}}"
                     [matTooltipPosition]="this.TooltipPosition">
                </div>

                <div class="{{this.ForwardTransitionConnectionDivClass(workflowTransition,workflowState)}}"
                     (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition, workflowState, false)"
                     matTooltip="{{this.TransitionConnectorTooltip}}"
                     [matTooltipPosition]="this.TooltipPosition">
                </div>
            </ng-container>

            <!-- Handle the last workflow state differently. -->
            <ng-container *ngIf="(iState == this.WorkflowStateCount - 1)">
                <div class="{{this.ForwardTransitionWorkflowStateDivClass(workflowTransition,workflowState)}}"
                     (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition, workflowState, true)"
                     matTooltip="{{this.TransitionConnectorTooltip}}"
                     [matTooltipPosition]="this.TooltipPosition">
                </div>
            </ng-container>

        </ng-container>

        <!-- Create a right margin (for spacing). -->
        <div class="forward-transition-right-margin-div"></div>

    </div>

    <!-- Define a transition name div that will overlay the above transition div. -->
    <div *ngIf="true"
         class="forward-workflow-transition-name-outer-div">
        <!-- Create a left margin (for spacing). -->
        <div class="forward-transition-left-margin-div"></div>

        <!-- Create additional spacing for any states before this transition. -->
        <div *ngFor="let workflowState of this.WorkflowStatesBeforeTransition"
             class="workflow-state-before-transition-name-div">
        </div>

        <div class="right-arrow-div">
            <mat-icon (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition,null,false)">arrow_right_alt</mat-icon>
        </div>

        <!-- Define a permissions popover. -->
        <ng-container>
            <ng-template #forwardPermissionsPopoverTitle><b>{{this.WorkflowTransitionPermissionsPopoverTitle}}</b></ng-template>
            <ng-template #forwardPermissionsPopoverContent>
                <ng-container *ngIf="this.PermissionCount == 0">
                    <p>No permissions defined.</p>
                </ng-container>
                <ng-container *ngIf="this.PermissionCount > 0">
                    <table>
                        <tr>
                            <th>Role</th>
                            <th>Permissions</th>
                        </tr>

                        <tr *ngFor="let permissionInfo of this.workflowTransition.Permissions">
                            <td>{{permissionInfo.roleName}}</td>
                            <td>{{this.GetPermissionNames(permissionInfo)}}</td>
                        </tr>
                    </table>
                </ng-container>
            </ng-template>
        </ng-container>

        <!-- Draw the transition's name. -->
        <!--
         Define one of two transition names, either:
             1. A transition that accepts a role name drop in 'Permissions' mode; or
             2. A transition that can be dragged to the trash in 'Build' mode.
        -->
        <div *ngIf="(this.ViewingMode == this.ViewingModePermissionsMode)"
             class="workflow-transition-name-div"
             droppable
             [dropScope]="this.DropScope"
             [dropEnabled]="true"
             (onDrop)="this.outputRoleDroppedOnWorkflowTransition($event,this.WorkflowTransition)"
             (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition,null,false)"
             [popoverTitle]="forwardPermissionsPopoverTitle"
             [ngbPopover]="forwardPermissionsPopoverContent"
             placement="bottom"
             #p="ngbPopover"
             triggers="manual"
             (hidden)="this.permissionsPopoverHidden()">
            <p>{{workflowTransition.name}}</p>
        </div>
        <div *ngIf="this.ViewingMode == this.ViewingModeBuilderMode"
             class="workflow-transition-name-div"
             draggable
             [dragScope]="this.DragScope"
             [dragData]="this.WorkflowTransition"
             (onDragStart)="this.outputExistingWorkflowTransitionDragStart($event,this.WorkflowTransition)"
             (onDragEnd)="this.outputExistingWorkflowTransitionDragEnd($event)"
             (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition,null,false)"
             [popoverTitle]="forwardPermissionsPopoverTitle"
             [ngbPopover]="forwardPermissionsPopoverContent"
             placement="bottom"
             #p="ngbPopover"
             triggers="manual"
             (hidden)="this.permissionsPopoverHidden()">
            <p>{{workflowTransition.name}}</p>
        </div>
        <!-- End the definition of two types of transition names. -->

        <div class="right-arrow-div">
            <mat-icon (click)="this.outputWorkflowTransitionStateClicked(this.WorkflowTransition,null,false)">arrow_right_alt</mat-icon>
        </div>

        <!-- Create additional spacing for any states after this transition. -->
        <div *ngFor="let workflowState of this.WorkflowStatesAfterTransition"
             class="workflow-state-after-transition-name-div">
        </div>

        <!-- Create a right margin. -->
        <div class="forward-transition-right-margin-div"></div>
    </div>

</ng-container>




